import { useTranslation } from 'react-i18next';
import { formatText } from '../../text/utils';
import { UserLocation } from '../../../redux/user/userSlice';
import { colors } from '../../../theme/colors';
import spacing from '../../../theme/spacing';
import AddNewUserLocationByDeviceButton from './AddNewUserLocationByDeviceButton';
import ChooseLocationHeader from './ChooseLocationHeader';
import UseYourDeviceInfoTooltip from './UseYourDeviceInfoTooltip';
import { useLocationSelectorContext } from '../LocationSelectorContext';

interface ChooseLocationByDeviceProps {
  onClose: () => void;
}

const ChooseLocationByDevice = ({ onClose }: ChooseLocationByDeviceProps) => {
  const { t, i18n } = useTranslation();

  const { onLocationSelect } = useLocationSelectorContext();

  return (
    <>
      <ChooseLocationHeader
        isApproximateLocation
        title={t('location.addLocationUsingDevice')}
        description={formatText(t('location.approximateLocationShortInfo'))}
      />

      <div
        style={{
          marginTop: spacing.large,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <AddNewUserLocationByDeviceButton
          onComplete={(newLocation) => {
            if (newLocation) {
              if (onLocationSelect) {
                onLocationSelect(newLocation);
              }
              onClose();
            }
          }}
        />
      </div>

      <div
        style={{
          color: colors.textGreyMedium,
          marginTop: spacing.mediumLarge,
        }}
      >
        <UseYourDeviceInfoTooltip />
      </div>
    </>
  );
};

export default ChooseLocationByDevice;
